import { API } from '../../../api';
import { axiosInstance } from '../../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getClaimsListEffectCancelToken = () => {};
export const getShipmentListEffect = (params) => {
  getClaimsListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetClaimSearch`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getClaimsListEffectCancelToken = c;
    }),
  });
};

export const getOverChargeSortingFieldsTypes = () => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetSortColumns`,
    method: 'get',
  });
};

export const deleteOverChargeClaimsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/DeleteClaim`,
    method: 'delete',
    params,
  });
};

export const getOverChargeClaimsExportEffect = (params) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetOCClaimDataForExport`,
    method: 'get',
    params,
  });
};

export const getOverChargeClaimDetailsEffect = (FBOCKey) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetClaim`,
    method: 'get',
    params: { FBOCKey },
  });
};

export const getOverChargeClaimStatusListEffect = () => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetClaimStatus`,
    method: 'get',
  });
};

export const getOverChargeClaimReasonListEffect = () => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetClaimReason`,
    method: 'get',
  });
};

export const getOverChargeClaimTypeListEffect = () => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetClaimType`,
    method: 'get',
  });
};

export const saveOverChargeClaimDetailsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/SaveClaim`,
    method: 'post',
    data,
  });
};
export const checkDuplicateOverChargeClaimDetailsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/CheckDuplicateClaim`,
    method: 'post',
    data,
  });
};

export const overChargeClaimGetCarrierInfo = (CarrierKey) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetCarrierInfo`,
    method: 'get',
    params: { CarrierKey },
  });
};

export const sendOverChargeClaimPdfToCarrierEffect = (data) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/SendMailToTransportationProvider`,
    method: 'post',
    data,
  });
};

export const getOverChargeClaimEmailDetailsEffect = (FBOCKey) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetClaimEmailNotification`,
    method: 'get',
    params: { FBOCKey },
  });
};

export const getOverChargeItemsFromExcelEffect = (data) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetClaimItemsFromExcel`,
    method: 'post',
    data,
  });
};

export const getOCClaimTableViewColumn = (GridName = 'OverChargeClaims') => {
  return axiosInstance.request({
    url: `${API.SECURITY}/GetGridColumnOptions`,
    method: 'get',
    params: { GridName: GridName },
  });
};

export const saveOCClaimTableViewColumn = (data) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/SaveGridColumnOption`,
    method: 'post',
    data,
  });
};

export const getOCClaimNotesEffect = ({
  fbOcKey,
  pageIndex,
  sortColumn = 'SequenceNo',
  sortDirection = 'DESC',
  pageSize = 10,
}) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetClaimComments`,
    method: 'get',
    params: {
      fbOcKey,
      pageIndex,
      sortColumn,
      sortDirection,
      pageSize,
    },
  });
};

export const getOCClaimSettlementsEffect = ({
  fbOcKey,
  pageIndex,
  sortColumn = 'SettlementSeq',
  sortDirection = 'DESC',
  pageSize = 10,
}) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetClaimSettlements`,
    method: 'get',
    params: {
      fbOcKey,
      pageIndex,
      sortColumn,
      sortDirection,
      pageSize,
    },
  });
};

export const getOCClaimItemsEffect = ({
  fbOcKey,
  pageIndex,
  sortColumn = 'itemID',
  sortDirection = 'DESC',
  pageSize = 10,
}) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetClaimItems`,
    method: 'get',
    params: {
      fbOcKey,
      pageIndex,
      sortColumn,
      sortDirection,
      pageSize,
    },
  });
};
export const applyClaimRecoveryPercentEffect = ({ fbOcKey, percentage }) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/ApplyClaimRecovery`,
    method: 'post',
    data: {
      fbOcKey,
      percentage,
    },
  });
};
